/* import __COLOCATED_TEMPLATE__ from './button.hbs'; */
import Component from '@ember/component';
export default Component.extend({
  tagName: '',
  /**
   * Forces the button to be in either the left or right positions
   *
   * @argument position
   * @type {"left" | "right"}
   */
  position: null,
  /**
   * Turns the button into a text link style and displays the provided label as the text.
   * (mutually exclusive with "icon" argument)
   *
   * @argument label
   * @type {String}
   */
  label: null,
  /**
   * Use an icon as the button (mutually exclusive with "label" argument)
   *
   * @argument icon
   * @type {String}
   */
  icon: null
});